module.exports = __webpack_public_path__ + "img/5-4-service.f4a0a651.jpg";